import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { uuidv4, sendNotification } from '../../utils'
import Socket from '../../utils/sockets'
import { Button } from 'antd'
import AWS from '../../utils/aws-config.js'

export class MasiveUploadClient extends Component {

  constructor(props) {
    super(props)
    AWS.config.setPromisesDependency();
    
    this.state = {
      clear: false
    }
  }


  handleOnChange = e => {
    this.setState({
      file: e.target.files[0],
      clear: false
    })
  }

  handleUpload = () => {
    const { file } = this.state
    const { intl } = this.props
    const uuid = uuidv4()
    let bucket = ''
    const key = `csv/${uuid}.csv`

    if (!file) {
      sendNotification('error', intl, intl.formatMessage({ id: 'select_upload_destination' }))
      return
    }

    switch (process.env.REACT_APP_BUNKEY_ENV) {
      case 'production':
        bucket = 'bunkey-prod'
        break;
      case 'qa':
        bucket = 'bunkey-qa'
        break;
      default:
        bucket = 'bunkey-develop'
        break;
    }

    const upload = new AWS.S3.ManagedUpload({
      params: {
        Bucket: bucket,
        Key: key,
        Body: file
      },
      partSize: 5 * 1024 * 1024,
      queueSize: 1,
    })

    upload
      .promise()
      .then(respUpload => {
        if (respUpload.Bucket) {
          this.setState({
            file: null,
            clear: true
          }, () => {
            Socket.getInstance().emit('client_masive_upload_client', { uuid })
            sendNotification('success', intl, intl.formatMessage({ id: 'masive_client_upload_success' }))
          })
        } else {
          sendNotification('error', intl, intl.formatMessage({ id: 'error_upload' }))
        }
      }, err => {
        console.log('err', err)
      })
  }

  render() {
    const { newColor, intl } = this.props
    const { clear } = this.state
    return (
      <React.Fragment>
        <div className="title-bar">
          <div className="container" style={{ borderLeftColor: newColor }} >
            <span>Carga de clientes</span>
          </div>
        </div>
        <div className="assets-wrapper">
          <div className="container">
            <div style={{ margin: 10 }}><small>Descarga template <a href="/template/carga-clientes.csv">aquí</a></small></div>
            <div style={{ margin: 10 }}>{clear
              ? <input type="file" value={[]} onChange={this.handleOnChange} />
              : <input type="file" onChange={this.handleOnChange} />}
            </div>
            <div style={{ margin: 10 }}><Button type="primary" style={{ backgroundColor: newColor, borderColor: newColor }} onClick={this.handleUpload}>{intl.formatMessage({id: "upload_button"})}</Button></div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(MasiveUploadClient)))
